import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import nextId from 'react-id-generator';
import { useTranslations } from '../../hooks/use_translations.js';
import { useThemeContext } from '../../styles/themes/themes.js';
import { Tree } from '../Tree/Tree.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["getMoreChildren", "hasMoreChildren", "nodeById", "renderLabel"];
var prefix = "__dynamic_tree_placeholder__";
var TreeDynamic = function TreeDynamic(props) {
  var getMoreChildren = props.getMoreChildren,
    hasMoreChildren = props.hasMoreChildren;
    props.nodeById;
    var _renderLabel = props.renderLabel,
    rest = _objectWithoutProperties(props, _excluded);
  var _useThemeContext = useThemeContext(),
    localization = _useThemeContext.localization;
  var _useTranslations = useTranslations(localization === null || localization === void 0 ? void 0 : localization.translations),
    t = _useTranslations.t;
  var _React$useState = React.useState(rest.focusIndex),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusIndex = _React$useState2[0],
    setFocusIndex = _React$useState2[1];
  var _React$useState3 = React.useState(function () {
      return {
        key: nextId(),
        nodeById: getModifiedNodeById(props)
      };
    }),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    state = _React$useState4[0],
    setState = _React$useState4[1];
  return /*#__PURE__*/jsx(Tree, _objectSpread({
    focusIndex: focusIndex,
    onFocusIndexChange: setFocusIndex,
    getInitialHiddenIds: function getInitialHiddenIds(context) {
      var initialHiddenIds = new Set();
      context.traverseDepthFirst(function (descendantId) {
        var _context$getNodeConte;
        if (context.nodeById[descendantId].status === "placeholder" && ((_context$getNodeConte = context.getNodeContext(descendantId).getParentNode()) === null || _context$getNodeConte === void 0 ? void 0 : _context$getNodeConte.status) !== "loading") {
          initialHiddenIds.add(descendantId);
        }
      });
      return initialHiddenIds;
    },
    nodeById: state.nodeById,
    onExpand: function onExpand(_ref) {
      var context = _ref.context,
        node = _ref.node;
      if (node.status === "unloaded") {
        setState(function (prevState) {
          return {
            key: nextId(),
            nodeById: _objectSpread(_objectSpread({}, prevState.nodeById), {}, _defineProperty({}, context.id, _objectSpread(_objectSpread({}, node), {}, {
              status: "loading"
            })))
          };
        });
        return getMoreChildren({
          context: context,
          node: node
        }).then(function (moreNodeById) {
          setState(function (prevState) {
            var nextNodeById = _objectSpread(_objectSpread({}, prevState.nodeById), {}, _defineProperty({}, context.id, _objectSpread(_objectSpread({}, node), {}, {
              status: "loaded"
            })), getModifiedNodeById({
              hasMoreChildren: hasMoreChildren,
              nodeById: moreNodeById
            }));
            context.getChildIds().forEach(function (childId) {
              delete nextNodeById[childId];
            });
            return {
              key: nextId(),
              nodeById: nextNodeById
            };
          });
        }).catch(function () {
          setState(function (prevState) {
            return {
              key: nextId(),
              nodeById: _objectSpread(_objectSpread({}, prevState.nodeById), {}, _defineProperty({}, context.id, _objectSpread(_objectSpread({}, node), {}, {
                status: "error"
              })))
            };
          });
        });
      }
    },
    renderLabel: function renderLabel(_ref2) {
      var context = _ref2.context,
        node = _ref2.node;
      if (node.status === "placeholder") {
        var _context$getParentNod;
        if (((_context$getParentNod = context.getParentNode()) === null || _context$getParentNod === void 0 ? void 0 : _context$getParentNod.status) === "error") {
          return t("TreeDynamic.error");
        } else {
          return t("TreeDynamic.loading");
        }
      } else {
        return _renderLabel({
          context: context,
          node: node
        });
      }
    }
  }, rest), state.key);
};
TreeDynamic.displayName = "TreeDynamic";
function getModifiedNodeById(_ref3) {
  var hasMoreChildren = _ref3.hasMoreChildren,
    nodeById = _ref3.nodeById;
  var acc = {};
  for (var _i = 0, _Object$entries = Object.entries(nodeById); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      id = _Object$entries$_i[0],
      node = _Object$entries$_i[1];
    var status = hasMoreChildren({
      context: {
        id: id
      },
      node: node
    }) ? "unloaded" : "loaded";
    acc[id] = _objectSpread(_objectSpread({}, node), {}, {
      status: status
    });
    if (status === "unloaded") {
      acc[nextId(prefix)] = _objectSpread(_objectSpread({}, node), {}, {
        parentId: id,
        status: "placeholder"
      });
    }
  }
  return acc;
}

export { TreeDynamic };
